import { Session } from '@/lib/next-shim'
import { getEnv } from '@/lib/env'
import { shouldUseCustomBranding } from '@/utils/landing-variant'
import ZoomDocNYLandingClient from './ZoomDocNYLandingClient'

type ZoomDocNYLandingPageProps = {
    session?: Session
}

export default function ZoomDocNYLandingPage({ session }: ZoomDocNYLandingPageProps) {
    return <ZoomDocNYLandingClient session={session} />
}
